import store from "@/store";

const routes = [
  {
    path: "/sales/sales-quotation/:id",
    name: "salesquotation",
    props: true,
    component: () => import("@/views/main/modules/Sales/SalesQuotations/SalesQuotationComponentMain"),
    beforeEnter: (to, from, next) => {
      store
        .dispatch("checkAccessUser", to.params.id)
        .then((response) => {
          if (response == "fail") {
            next("/no-access");
          } else {
            next();
          }
        })
        .catch(() => {});
    },
    meta: {
      requiresAuth: true,
      title: "Sales Quotations",
      service: "0",
    },
  },
];

export default routes;
